import { useState } from "react";
import { BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useEntities } from "@/lib/queries";

export const AnnotationDialog = ({ uid, kind, onClose, onInsert }) => {
  const { data: ents = [] } = useEntities(uid);
  const list = ents.items || ents;
  const [text, setText] = useState("");
  const fromLore = (id) => {
    const e = list.find((x) => x.id === id);
    if (e) setText(`${e.name}${e.summary ? ` — ${e.summary}` : ""}`);
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="annotation-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{kind === "footnote" ? "Add a footnote" : "Add a note box"}</DialogTitle>
          <DialogDescription>{kind === "footnote" ? "A numbered marker goes where your cursor is; the note is listed at the end of the chapter in exports." : "A highlighted aside placed at your cursor."} Annotations don't count toward word totals.</DialogDescription>
        </DialogHeader>
        <Select onValueChange={fromLore}>
          <SelectTrigger data-testid="annotation-from-lore"><BookOpen className="mr-2 h-4 w-4" /><SelectValue placeholder="Fill from a Lore Bible entry (optional)" /></SelectTrigger>
          <SelectContent className="max-h-72">{list.map((e) => <SelectItem key={e.id} value={e.id}>{e.name}</SelectItem>)}</SelectContent>
        </Select>
        <Textarea value={text} onChange={(e) => setText(e.target.value)} rows={5} placeholder="Write the annotation…" data-testid="annotation-text" />
        <DialogFooter><Button disabled={!text.trim()} onClick={() => { onInsert(text.trim()); onClose(); }} data-testid="annotation-insert">Insert</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const insertAnnotation = (editor, kind, text) => {
  if (!editor) return;
  if (kind === "note") {
    editor.chain().focus().insertContent({ type: "codeBlock", attrs: { language: "note" }, content: [{ type: "text", text }] }).run();
    return;
  }
  const md = editor.storage.markdown.getMarkdown();
  const used = [...md.matchAll(/\\?\[\\?\^(\d+)\\?\]/g)].map((m) => Number(m[1]));
  const n = (used.length ? Math.max(...used) : 0) + 1;
  editor.chain().focus().insertContent(`[^${n}]`).run();
  editor.commands.insertContentAt(editor.state.doc.content.size, { type: "paragraph", content: [{ type: "text", text: `[^${n}]: ${text}` }] });
};
